import { getDepartments } from '@lib/api'
import { departmentsKeys } from '@lib/keys'
import { useQuery } from '@tanstack/react-query'

export const useDepartments = () => {
  return useQuery(departmentsKeys.all, () => getDepartments())
}
